export enum Roles {
  ADMIN = "admin",
  ADMINPORTAL = "admin_portal_cliente",
  ANALYST = "vendor",
  CLIENT = "customer",
  COMAO = "comao",
}
